'use client'

import React from 'react'

import { useTranslation } from '@/hooks/useDebugTranslations'

import Price from '../shared/Price'

interface Props {
  currency?: string
  price?: number
}

const AdministrationFee: React.FC<Props> = ({ currency, price }) => {
  const { t } = useTranslation()

  return price && price > 0 ? (
    <div className="border-semantic-global-border-light pt-primitive-16 flex justify-between border-t lg:border-0 lg:pt-0">
      <div className="flex max-w-70 flex-row justify-center">
        <div
          className="typography-body-md-regular lg:typography-body-md-regular text-semantic-global-text-default flex"
          data-e2e="administration-fee"
        >
          {t('ADMFEE')}
        </div>
      </div>
      <div className="typography-body-md-regular lg:typography-body-md-regular text-semantic-global-text-default">
        <Price currency={currency} dataAttr="total-administration-fee-price" price={price} />
      </div>
    </div>
  ) : null
}

export default AdministrationFee
